import { SET_USER_DETAILS } from "../constants";

const initialState = [];

export const userDetailsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_USER_DETAILS: {
            state = payload;
            return state;
        }
        default: {
            return state;
        }
    }
};